import React, {useCallback, useEffect, useState} from 'react';
import {get} from '../../../api';
import {useSelector} from 'react-redux'
import CompensationPlanDisplay from './CompensationPlanDisplay';

function CompensationPlansRender(){
  const compensation_plans_enabled = useSelector(useCallback((state)=>state.settings.compensation_plans_enabled,[]))
  if(compensation_plans_enabled){
    return <FetchAndRender />
  }else{
    return null
  }
}

function FetchAndRender(props) {
  const [plans, setPlans] = useState([])
  useEffect(()=>{
    //get list of plans
    get('/compensationplans/v2').then(({plans})=>{
      setPlans(plans)
    })
  },[])
  return (
      <>
        {
          plans && plans.map((i)=><CompensationPlanDisplay planId={i.id} key={String(i.id)} />)
        }
      </>
  );
}

export default CompensationPlansRender;
